module.exports = __webpack_public_path__ + "img/case-bj11.ea5798be.png";